import React from 'react';
import PropTypes from 'prop-types';
import { ProbablePitchersDisplay, ProbablePitchersTitle, Pitcher, PitcherContainer, PitcherStatsTable } from './ProbablePitchers.style';
import { PlayerMatchupTypes } from '@mlb/react-patterns/v4/components/PlayerMatchup/playerMatchup.types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import GameContextPlayerDuel from '../PlayerDuel/GameContextPlayerDuel';
import { HeadshotTypes } from '@mlb/react-patterns/v4/components/Headshot/headshot.types';

const { SPOTS, SILO } = HeadshotTypes;
const TEAM_NAME_PREFIX = ', ';
const buildRecordString = ({ wins, losses }) => {
    return wins >= 0 && losses >= 0 ? wins + ' - ' + losses : '';
};
const ProbablePitchers = ({ probablePitchers, teams, duelDisplay = false }) => {
    const translate = useTranslate();
    const PitcherStatsTableHeader = [{
        content: translate('labelBrief_win_loss', 'W - L'),
        dataField: 'record',
        alignment: 'center'
    },
    {
        content: translate('labelBrief_era', 'ERA'),
        dataField: 'era',
        alignment: 'center'

    }, {
        content: translate('labelBrief_p_so', 'SO'),
        dataField: 'strikeOuts',
        alignment: 'center'

    }, {
        content: translate('labelBrief_whip', 'WHIP'),
        dataField: 'whip',
        alignment: 'center'

    }, {
        content: translate('labelBrief_p_bb', 'BB'),
        dataField: 'baseOnBalls',
        alignment: 'center'

    }];

    const {
        home: {
            person: {
                id: homePitcherId,
                boxscoreName: homePitcherName,
                pitchHand: {
                    code: homePitcherHand
                } = {}
            } = {},
            seasonStats: {
                pitching: homePitcherStats = {}
            } = {}
        } = {},
        away: {
            person: {
                id: awayPitcherId,
                boxscoreName: awayPitcherName,
                pitchHand: {
                    code: awayPitcherHand
                } = {}
            } = {},
            seasonStats: {
                pitching: awayPitcherStats = {}
            } = {}
        } = {}
    } = probablePitchers || {};
    const homePitcherRecord = buildRecordString(homePitcherStats);
    const awayPitcherRecord = buildRecordString(awayPitcherStats);

    const probablePitchersLabel = translate('scores_probable_pitchers', 'Probable Pitchers');
    const awayTeamLabel = TEAM_NAME_PREFIX + teams?.away.toUpperCase();
    const homeTeamLabel = TEAM_NAME_PREFIX + teams?.home.toUpperCase();
    return (
        <ProbablePitchersDisplay>
            <ProbablePitchersTitle>{probablePitchersLabel}</ProbablePitchersTitle>
            {duelDisplay
                ? <GameContextPlayerDuel gameStateOverride={'P'} probablePitchers={probablePitchers}/>
                : <>
                    <PitcherContainer>
                        <Pitcher
                            playerId={awayPitcherId}
                            type={PlayerMatchupTypes.PITCHERPREGAME}
                            name={awayPitcherName}
                            pitchHand={awayPitcherHand}
                            alignment='left'
                            playerStats={null}
                            playerStatsInline={true}
                            customPlayerInfo={awayTeamLabel}
                            headshotWidth={'44px'}
                            headshotType={awayPitcherId ? SPOTS : SILO}
                        />
                        <PitcherStatsTable
                            thead={PitcherStatsTableHeader}
                            tbody={[{ ...awayPitcherStats, record: awayPitcherRecord }]}
                            tableFixed={true}

                        />

                    </PitcherContainer>
                    <PitcherContainer>
                        <Pitcher
                            playerId={homePitcherId}
                            type={PlayerMatchupTypes.PITCHERPREGAME}
                            name={homePitcherName}
                            pitchHand={homePitcherHand}
                            alignment='left'
                            playerStats={null}
                            playerStatsInline={true}
                            customPlayerInfo={homeTeamLabel}
                            headshotWidth={'44px'}
                            headshotType={homePitcherId ? SPOTS : SILO}
                        />
                        <PitcherStatsTable
                            thead={PitcherStatsTableHeader}
                            tbody={[{ ...homePitcherStats, record: homePitcherRecord }]}
                            tableFixed={true}
                        />
                    </PitcherContainer>
                </>}
        </ProbablePitchersDisplay>
    );
};

ProbablePitchers.propTypes = {
    probablePitchers: PropTypes.object,
    teams: PropTypes.object,
    duelDisplay: PropTypes.bool
};

export default ProbablePitchers;
